import { render, staticRenderFns } from "./RiwayatTambahProduct.vue?vue&type=template&id=6ac6a896&scoped=true&"
import script from "./RiwayatTambahProduct.vue?vue&type=script&lang=js&"
export * from "./RiwayatTambahProduct.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatTambahProduct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RiwayatTambahProduct.vue?vue&type=style&index=1&id=6ac6a896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac6a896",
  null
  
)

export default component.exports